import { ChunkEntry } from '@atlassian/bitkit-diff';

export function updateLinePositions(
  chunks: ChunkEntry[],
  startIndex: number = 0
) {
  let position = 1;
  if (startIndex > 0) {
    const previousChunkLines = chunks[startIndex - 1].changes;
    const lastPosition =
      previousChunkLines[previousChunkLines.length - 1]?.position;
    if (lastPosition) {
      position = lastPosition + 1;
    }
  }

  for (let i = startIndex; i < chunks.length; i++) {
    const chunk = chunks[i];
    for (let j = 0; j < chunk.changes.length; j++) {
      const line = chunk.changes[j];
      line.position = position;
      position += 1;
    }
  }

  return chunks;
}
